import { render, staticRenderFns } from "./NewSaleAccountModal.vue?vue&type=template&id=2f2c0215&scoped=true"
import script from "./NewSaleAccountModal.vue?vue&type=script&lang=ts"
export * from "./NewSaleAccountModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c0215",
  null
  
)

export default component.exports